import "./background.scss";
import React from "react";

// Background component
function Background() {
  return (
    <div className="background">
      <ul className="circles">
        <li />
        <li />
        <li />
        <li />
        <li />
        <li />
        <li />
        <li />
        <li />
        <li />
      </ul>
    </div>
  );
}

export default Background;
